(() => {
  if (window.__productOriginalSwatchesLoaded) return;
  window.__productOriginalSwatchesLoaded = true;

  const productCache = new Map();
  const cardProductCache = new Map();
  let originalCardConfigPromise = null;

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const getOptionValue = (variant, optionIndex) => {
    if (Array.isArray(variant.options)) return variant.options[optionIndex];
    return variant[`option${optionIndex + 1}`];
  };

  const getOriginalProduct = (handle, sectionId) => {
    const cacheKey = `${handle}:${sectionId}`;
   const storageKey = `original-swatches:v3:${cacheKey}`;

    if (!productCache.has(cacheKey)) {
      let storedProduct = null;

      try {
        storedProduct = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (error) {
        // Ignore unavailable or invalid session storage.
      }

      if (storedProduct?.variants && typeof storedProduct.swatchConfig === 'string') {
        productCache.set(cacheKey, Promise.resolve(storedProduct));
        return productCache.get(cacheKey);
      }

      // Request only the main-product section instead of downloading the full page.
      const url = `/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`;
      const request = fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      }).then((response) => {
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
        return response.text();
      }).then((html) => {
        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        const picker = documentCopy.querySelector(
          `variant-radios[data-product-handle="${handle}"]`
        );
        const variantsElement = picker?.querySelector('[data-localized-product-variants]');
        const configElement = picker?.querySelector('[data-original-swatch-config]');

        if (!variantsElement || !configElement) {
          throw new Error('Original swatch data was not found');
        }

        const swatchStylesById = {};

picker
  .querySelectorAll('[data-original-color-option] input[data-option-value-id]')
  .forEach((input) => {
    const valueId = input.dataset.optionValueId;
    const label = input
      .closest('magnet-element')
      ?.querySelector('label.color-swatch');
    const style = label?.getAttribute('style');

    if (valueId && style) {
      swatchStylesById[valueId] = style;
    }
  });

const productData = {
  variants: JSON.parse(variantsElement.textContent || '[]').map((variant) => ({
    id: variant.id,
    options: Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3],
  })),
  swatchConfig: JSON.parse(configElement.textContent || '""'),
  swatchStylesById,
};

        try {
          sessionStorage.setItem(storageKey, JSON.stringify(productData));
        } catch (error) {
          // The in-memory cache still works if session storage is unavailable or full.
        }

        return productData;
      });

      productCache.set(cacheKey, request);
    }

    return productCache.get(cacheKey);
  };

  const getOriginalCardProduct = (handle) => {
  const cacheKey = String(handle || '');
  const storageKey = `original-card-swatches:v1:${cacheKey}`;

  if (!cardProductCache.has(cacheKey)) {
    let storedProduct = null;

    try {
      storedProduct = JSON.parse(
        sessionStorage.getItem(storageKey) || 'null'
      );
    } catch (error) {
      // Ignora dados inválidos ou sessionStorage indisponível.
    }

    if (storedProduct?.variants) {
      cardProductCache.set(
        cacheKey,
        Promise.resolve(storedProduct)
      );

      return cardProductCache.get(cacheKey);
    }

    const url = `/products/${encodeURIComponent(handle)}.js`;

    const request = fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Product JSON request failed: ${response.status}`
          );
        }

        return response.json();
      })
      .then((product) => {
        const productData = {
          variants: (product.variants || []).map((variant) => ({
            id: variant.id,
            options: Array.isArray(variant.options)
              ? variant.options
              : [
                  variant.option1,
                  variant.option2,
                  variant.option3,
                ],
          })),
        };

        try {
          sessionStorage.setItem(
            storageKey,
            JSON.stringify(productData)
          );
        } catch (error) {
          // O cache em memória continuará funcionando.
        }

        return productData;
      });

    cardProductCache.set(cacheKey, request);
  }

  return cardProductCache.get(cacheKey);
};


  const getOriginalCardSwatchConfig = () => {
 const storageKey = 'original-card-swatches:config:v2';

  if (originalCardConfigPromise) {
    return originalCardConfigPromise;
  }

  let storedConfig = '';

  try {
    storedConfig =
      sessionStorage.getItem(storageKey) || '';
  } catch (error) {
    // Ignora caso o sessionStorage esteja indisponível.
  }

  if (storedConfig) {
    originalCardConfigPromise = Promise.resolve(storedConfig);
    return originalCardConfigPromise;
  }

  originalCardConfigPromise = fetch('/', {
    credentials: 'same-origin',
    headers: {
      Accept: 'text/html',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Original config request failed: ${response.status}`
        );
      }

      return response.text();
    })
    .then((html) => {
      const documentCopy = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const configElement = documentCopy.querySelector(
        '#OriginalSwatchConfig'
      );

      if (!configElement) {
        throw new Error(
          'Original swatch config was not found'
        );
      }

      const configText = JSON.parse(
        configElement.textContent || '""'
      );

      try {
        sessionStorage.setItem(storageKey, configText);
      } catch (error) {
        // O cache em memória continuará funcionando.
      }

      return configText;
    });

  return originalCardConfigPromise;
};
  const getSwatchConfig = (configText) => {
    const config = new Map();

    String(configText)
      .split(/\r?\n/)
      .forEach((line) => {
        const separatorIndex = line.indexOf(':');
        if (separatorIndex < 1) return;

        const key = normalize(line.slice(0, separatorIndex).trim());
        const value = line.slice(separatorIndex + 1).trim();

        if (key && value && !config.has(key)) config.set(key, value);
      });

    return config;
  };

   const applyConfiguredSwatch = (label, configuredValue) => {
    const colors = configuredValue.split(',').map((color) => color.trim());
    const isHexColor = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

    if (colors.length === 2 && colors.every((color) => isHexColor.test(color))) {
      const [firstColor, secondColor] = colors;

      label.style.setProperty('--swatch-background', firstColor);
      label.style.backgroundImage =
        `conic-gradient(from 90deg, ${firstColor} 25%, ${secondColor} 0 50%, ${firstColor} 0 75%, ${secondColor} 0)`;
      return;
    }

    if (configuredValue.includes('#')) {
      label.style.setProperty('--swatch-background', configuredValue);
      label.style.removeProperty('background-image');
      return;
    }

    let imageUrl = configuredValue;

    if (configuredValue.startsWith('//')) {
      imageUrl = `${window.location.protocol}${configuredValue}`;
    } else if (!/^https?:\/\//i.test(configuredValue)) {
      imageUrl = `/cdn/shop/files/${configuredValue
        .split('/')
        .map((part) => encodeURIComponent(part))
        .join('/')}`;
    }

    label.style.setProperty('--swatch-background', 'transparent');
    label.style.backgroundImage = `url("${imageUrl.replace(/"/g, '%22')}")`;
  };

  const revealPicker = (picker) => {
    picker.dataset.originalSwatchesResolved = 'true';
    picker.removeAttribute('data-original-swatches-pending');
  };

const revealCardSwatches = (group) => {
  group.dataset.originalCardSwatchesResolved = 'true';
  group.removeAttribute('data-original-card-swatches-pending');
};

const resolveCardSwatches = async (group) => {
  if (
    group.dataset.originalCardSwatchesResolved === 'true'
  ) {
    return;
  }

  // Na loja principal, o Liquid já possui os nomes originais.
  if (group.dataset.localeRoot === '/') {
    revealCardSwatches(group);
    return;
  }

  const handle = group.dataset.productHandle;
  const optionIndex = Number(group.dataset.optionIndex);

  const swatches = group.querySelectorAll(
    '[data-original-swatch-variant-id]'
  );

  if (
    !handle ||
    !Number.isInteger(optionIndex) ||
    !swatches.length
  ) {
    revealCardSwatches(group);
    return;
  }

  try {
    const [
      originalProduct,
      originalConfigText,
    ] = await Promise.all([
      getOriginalCardProduct(handle),
      getOriginalCardSwatchConfig(),
    ]);

    const swatchConfig = getSwatchConfig(
      originalConfigText
    );

    if (!swatchConfig.size) return;

    const originalVariants = new Map(
      originalProduct.variants.map((variant) => [
        String(variant.id),
        variant,
      ])
    );

    swatches.forEach((item) => {
      const variantId = String(
        item.dataset.originalSwatchVariantId
      );

      const originalVariant =
        originalVariants.get(variantId);

      if (!originalVariant) return;

      const originalValue = getOptionValue(
        originalVariant,
        optionIndex
      );

      const configuredValue = swatchConfig.get(
        normalize(originalValue)
      );

      const swatch = item.querySelector(
        '.color-swatch'
      );

      if (!configuredValue || !swatch) return;

      swatch.dataset.originalSwatchValue =
        originalValue;

      applyConfiguredSwatch(
        swatch,
        configuredValue
      );
    });
  } catch (error) {
    // Mantém o fallback do tema se a consulta falhar.
  } finally {
    revealCardSwatches(group);
  }
};

  const resolvePicker = async (picker) => {
    if (picker.dataset.originalSwatchesResolved === 'true') return;

    // The primary storefront already renders the original option names in Liquid.
    if (/^\/products\//.test(window.location.pathname)) {
      revealPicker(picker);
      return;
    }

    const handle = picker.dataset.productHandle;
    const sectionId = picker.dataset.section;
    const variantDataElement = picker.querySelector('[data-localized-product-variants]');
    const colorGroups = picker.querySelectorAll('[data-original-color-option]');

    if (!handle || !sectionId || !variantDataElement || !colorGroups.length) {
      revealPicker(picker);
      return;
    }

    let localizedVariants = [];

    try {
      localizedVariants = JSON.parse(variantDataElement.textContent || '[]');
    } catch (error) {
      revealPicker(picker);
      return;
    }

    try {
      const originalProduct = await getOriginalProduct(handle, sectionId);
      const swatchConfig = getSwatchConfig(originalProduct.swatchConfig);
      if (!swatchConfig.size) return;

      const originalVariants = new Map(
        originalProduct.variants.map((variant) => [String(variant.id), variant])
      );

      colorGroups.forEach((group) => {
        const optionPosition = Number(
          String(group.dataset.optionIndex || '').replace('option', '')
        );
        const optionIndex = optionPosition - 1;

        if (optionIndex < 0) return;

       group.querySelectorAll('input[data-option-value]').forEach((input) => {
  const label = input
    .closest('magnet-element')
    ?.querySelector('label.color-swatch');

  if (!label) return;

  const valueId = input.dataset.optionValueId;
  const originalStyle =
    originalProduct.swatchStylesById?.[valueId];

  if (originalStyle) {
    label.setAttribute('style', originalStyle);
    return;
  }

  // Mantém o método anterior como reserva se o ID não for encontrado.
  const localizedValue = input.dataset.optionValue;
  const localizedVariant = localizedVariants.find(
    (variant) =>
      String(getOptionValue(variant, optionIndex)) === localizedValue
  );

  if (!localizedVariant) return;

  const originalVariant = originalVariants.get(
    String(localizedVariant.id)
  );
  if (!originalVariant) return;

  const originalValue = getOptionValue(originalVariant, optionIndex);
  const configuredValue = swatchConfig.get(normalize(originalValue));

  if (!configuredValue) return;

  label.dataset.originalSwatchValue = originalValue;
  applyConfiguredSwatch(label, configuredValue);
});

      });

    } catch (error) {
      // Keep the theme's native swatch fallback if the original product cannot be loaded.
    } finally {
      revealPicker(picker);
    }
  };

  const initialize = (root = document) => {
  const initializeRoot =
    root instanceof Element ? root : document;

  if (
    initializeRoot.matches?.(
      'variant-radios[data-product-handle]'
    )
  ) {
    resolvePicker(initializeRoot);
  }

  if (
    initializeRoot.matches?.(
      '[data-original-card-swatches]'
    )
  ) {
    resolveCardSwatches(initializeRoot);
  }

  initializeRoot
    .querySelectorAll('variant-radios[data-product-handle]')
    .forEach((picker) => resolvePicker(picker));

  initializeRoot
    .querySelectorAll('[data-original-card-swatches]')
    .forEach((group) => resolveCardSwatches(group));
};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        initialize(node);
      }
    });
  });
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

})();
